import { GetterTree } from 'vuex'
import { ApiErrorsState } from './types'
import { RootState } from '@/store/types'

export const getters: GetterTree<ApiErrorsState, RootState> = {}
